import apiRoutes from './ApiRoutes'
import locales from './Locales'

export default [
    apiRoutes,
    locales
]
